import { useHandler } from "@redotech/react-util/hook";
import { showNotification } from "@redotech/redo-web/alert";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { memo, useContext, useEffect } from "react";
import { RedoAdminRpcClientContext } from "./app/redo-admin-rpc-client-provider";
import { setAdminRateRefreshHandler } from "./rate-refresh";

export const AdminRateRefresh = memo(function AdminRateRefresh() {
  const rpc = useContext(RedoAdminRpcClientContext);

  const handle = useHandler((teamId: string) => {
    if (!rpc) {
      return;
    }
    showNotification({
      notificationKey: "rates",
      title: "Refresh rates?",
      children: (dismiss) => (
        <RedoButton
          hierarchy="primary"
          onClick={() => {
            void rpc
              .refreshTeamRates({ teamId })
              .catch((error) => {
                console.error("Failed to start rate refresh:", error);
              })
              .finally(dismiss);
          }}
          size="xs"
          text="Refresh rates"
        />
      ),
    });
  });

  useEffect(() => {
    setAdminRateRefreshHandler(handle);
    return () => setAdminRateRefreshHandler(undefined);
  }, [handle]);

  return null;
});
